import React from 'react';

import Button from '@atlaskit/button';
import { openDialog } from 'src/services/jira';

import { locationReload } from 'src/lib/history';

const RemoveAccountsConnectionButton = ({ accountsMapping }) => {
  const { id } = accountsMapping || {};

  const onRemove = (e) => {
    openDialog(`/integration-jira-ui/settings/modal/confirm_accounts_mapping_remove?accountsMappingId=${id}`, {
      onClose: () => { locationReload(); },
      minHeight: 440,
    });
  };

  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
      <Button onClick={onRemove}>Remove Account Integration</Button>
    </div>
  );
};

export default RemoveAccountsConnectionButton;
